module.exports = __webpack_public_path__ + "img/festoon.01a0ce34.svg";